import { HttpResponse } from './unpack/types'

async function unpack<T>(promise: Promise<HttpResponse<T>>) {
  return promise.then((response) => response.data)
}

export default unpack
